<template>
    <md-menu ref="menuMainRef"
             class="menu-container"
             :class="{'menu-container-col': isCollapse}"
             unique-opened>
        <!-- logo -->
        <logo :isCollapse='isCollapse'></logo>
        <!-- 搜索框 -->
        <menu-search ref="menuSearchRef" :isCollapse='isCollapse' :menus='menus' @disableEnter='isDisableEnter=true' @goRouter='goRouter'></menu-search>
         <!--菜单栏-->
        <div class="menu-item-container" :class="{'disable-Enter': isDisableEnter}">
            <div v-for="(item, index) in menus"
                 :key="item.fdId"
                 class="menu-item-content"
                 @click="mouseEnter(item, index)"
                 @mouseleave="mouseLeave(item, index, $event)">
                <!-- 一级菜单 -->
                <md-submenu :index="item.fdId" :title="item.fdName">
                    <template #title>
                        <!-- 最左侧蓝色竖条 -->
                        <div class="border-left"></div>
                        <!-- 图标 -->
                        <md-icon class="icon-common" :name="item.fdFrontIcon || 'md-icon-folder-opened' "></md-icon>
                        <!-- 名称 -->
                        <span v-show="!isCollapse" class="menu-title">
                            {{ item.fdName }}
                        </span>
                    </template>
                </md-submenu>
                <!-- 悬浮窗显示二、三级菜单栏组件 -->
                <MenuPopver :ref="item.fdKey" :menu-data="item" :isCollapse='isCollapse' @goRouter='goRouter'></MenuPopver>
            </div>
        </div>
    </md-menu>
</template>
<script>
import logo from './components/logo.vue';
import menuSearch from './components/menu-search.vue';
import MenuPopver from './components/menu-popover.vue';
import { systemMark } from '@/utils/tool';

export default {
    name: 'LeftSidebar',
    components: {
        logo,
        menuSearch,
        MenuPopver,
    },
    props: {
        isCollapse: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        menus() {
            const { authority } = this.$store.state;
            // const moduleLink = window.location.href.indexOf('.html') > -1 ? window.location.pathname : window.location.pathname + 'index.html';
            const filterRoutes = authority.filter(item => item.fdKey === systemMark());
            const menu = JSON.parse(JSON.stringify(filterRoutes.length ? filterRoutes[0].subNodes : []));
            return menu;
        },
    },
    data() {
        return {
            isDisableEnter: false,
        };
    },
    methods: {
        mouseEnter(item, index) {
            // 禁用状态，用于搜索框点击菜单时，不展示2/3级菜单
            if (this.isDisableEnter) return;
            this.$refs[item.fdKey][0].showPopover(index);
            // 有滚动条时，有可能会出现多个悬浮窗，所以需要关闭其他悬浮窗
            this.menus.forEach((menu) => {
                if (menu.fdId !== item.fdId) {
                    this.$refs[menu.fdKey][0].closePopover();
                }
            });
        },
        mouseLeave(item, index, e) {
            // 兼容存在滚动条的情况，鼠标移出时，判断是否移入了滚动条
            if (e.relatedTarget?.tagName === 'ASIDE') return;
            this.isDisableEnter = false;
            this.$refs[item.fdKey][0].closePopover();
        },
        goRouter(link, menu) {
            this.link = link;
            if (link.indexOf('open=browser') > -1) {
                window.open(link);
            } else {
                this.$router.push(link);
            }
        },
    },
    // mounted() {
    //     debugger;
    //     const moduleLink = window.location.href.indexOf('.html') > -1 ? window.location.pathname : window.location.pathname + 'index.html';
    //     const filterRoutes = this.menus.filter(item => moduleLink.indexOf(item.fdFrontLink) > -1);
    //     const menu = JSON.parse(JSON.stringify(filterRoutes.length ? filterRoutes[0].subNodes : []));
    // },
};
</script>
<style lang="less" scoped>
@import url("../../../../styles/vars.less");
.menu-container {
    width: @leftSidebar-width;
    height: 100%;
    // transition: all 0.1s ease-in;
}

.menu-item-container {
    position: relative;
    /deep/.md-submenu__icon-arrow {
        transform: rotateZ(270deg);
        right: 0px !important;
        top: 24px;
    }
    .menu-item-content {
        width: @leftSidebar-width;
        /deep/ .md-submenu__icon-arrow {
            margin-right: 25px;
        }
    }
    .menu-item-content:hover {
        background-color: #E7F2FF;
        .icon-common {
            color: @default-blue;
        }
        .menu-title {
            color: @default-blue;
        }
        /deep/.md-submenu__icon-arrow {
            color: @default-blue;
            transform: rotateZ(90deg);
        }
        .border-left {
            visibility: initial !important;
        }
    }
    .menu-title {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 400;
        color: #212B36;
        line-height: 14px;
    }
    /deep/.md-submenu{
        position: relative;
        .md-submenu__title {
            height: 48px;
            line-height: 48px;
            padding-left: 15px !important;
            padding-right: 17px !important;
            align-items: center;
            display: flex;
            .border-left {
                width: 2px;
                background-color: @default-blue;
                height: 100%;
                position: absolute;
                left: 0px;
                visibility: hidden;
            }
            .icon-common {
                margin-right: 8px;
            }
        }
    }
}
// 禁用状态，用于搜索框点击菜单时，不展示2/3级菜单
.disable-Enter {
    .menu-item-content:hover {
        cursor: not-allowed;
        background-color: #fff !important;
        .icon-common {
            color: #000;
        }
        .menu-title {
            color: #000;
        }
        /deep/.md-submenu__icon-arrow {
            color: #000;
            transform: rotateZ(270deg);
        }
        .border-left {
            visibility: hidden !important;
        }
    }
    /deep/.md-submenu__title:hover {
        cursor: not-allowed;
        background-color: #fff;
    }
}

// 折叠态
.menu-container-col {
    width: @leftSidebar-width-col;
    /deep/.md-submenu__icon-arrow {
        visibility: hidden;
    }
    /deep/.md-submenu .md-submenu__title {
        padding-left: 24px !important;
    }
}
</style>
